import { createInjectionKey as n } from "../../_utils/vue/create-injection-key.js";
const e = n("n-input");
export {
  e as inputInjectionKey
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/input/src/interface.js
// module id = 921
// module chunks = 41